// src/pages/PaymentPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { getAuth } from 'firebase/auth';

const BACKEND_URL = "https://coursehub-282e6.uc.r.appspot.com"; 

const PAYPAL_CLIENT_ID = 'AYljMEX2Kny1fs7wrVGIZn0veLFjzsm7J67VYQ5G1ji7X4ydVxId8KXIzo4oQA9jyzeci_x7SMwZXs-N'
// staging paypal id
//const PAYPAL_CLIENT_ID = "AdESvq2ApNt41qdfi9CJgvdpYWl_mneT_nmFuHI0Q_kZmyb9StZwGLptSCxlU2OOyhoZR8RMtKS6ZeuY";
const PRO_PLAN_PRICE = "4.99";

function PaymentPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const auth = getAuth();

  const handleApprove = async (data, actions) => {
    setMessage('Finalizing your payment, please wait...');

    try {
      const user = auth.currentUser;
      if (!user) {
        setMessage("Authentication error: You must be logged in to complete a purchase.");
        return;
      }
      const idToken = await user.getIdToken();

      const response = await fetch(`${BACKEND_URL}/api/payment/verify-purchase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          orderID: data.orderID,
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setMessage('Success! You are now a Pro member. Redirecting...');
        setTimeout(() => navigate('/mentorai'), 3000);
      } else {
        setMessage(result.error || 'An unknown error occurred during verification. Please contact support.');
      }
    } catch (error) {
      console.error("Frontend verification call failed:", error);
      setMessage(`A network error occurred: ${error.message}. Please try again or contact support.`);
    }
  };

  return (
    <div className="payment-page" style={{ padding: '40px', maxWidth: '600px', margin: 'auto', textAlign: 'center' }}>
      <div className="payment-container">
        <header>
          <h1>Complete Your Purchase</h1>
          {/* --- MODIFICATION 1: Update the description text --- */}
          {/* This text now clearly states it's a one-time payment for 2 months of access. */}
          <p style={{ fontSize: '18px', color: '#555', lineHeight: '1.6' }}>
            Unlock **CourseHub Pro** with a <strong style={{color: '#000'}}>one-time payment</strong> of <strong>${PRO_PLAN_PRICE}</strong> for a <strong style={{color: '#000'}}>2-month access period</strong>.
          </p>
          <p style={{ fontSize: '14px', color: '#777' }}>
            This is not a recurring subscription.
          </p>
        </header>
        
        {message ? (
          <div className="status-message" style={{ marginTop: '40px', fontSize: '18px', fontWeight: 'bold' }}>
            {message}
          </div>
        ) : (
          <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, currency: "USD", intent: "capture" }}>
            <PayPalButtons
              style={{ layout: "vertical" }}
              createOrder={(data, actions) => {
                return actions.order.create({
                  purchase_units: [{
                    // --- MODIFICATION 2: Update the PayPal order description ---
                    // This description appears on the PayPal checkout screen for added clarity.
                    description: "CourseHub Pro (2-Month Access)",
                    amount: { value: PRO_PLAN_PRICE }
                  }]
                });
              }}
              onApprove={handleApprove}
              onError={(err) => {
                setMessage(`A PayPal error occurred: ${err.message}`);
              }}
            />
          </PayPalScriptProvider>
        )}

        <footer style={{ marginTop: '20px' }}>
            {!message && (
              <button onClick={() => navigate('/upgrade')} style={{ background: 'none', border: 'none', color: '#673ab7', cursor: 'pointer', fontSize: '16px' }}>
                &larr; Go Back
              </button>
            )}
        </footer>
      </div>
    </div>
  );
}

export default PaymentPage;